(function() {
  'use strict';

  function readCalculatorConfig(root) {
    var config = {};
    var configElement = root.querySelector('[data-turf-calculator-config]');

    if (configElement) {
      try {
        config = JSON.parse(configElement.textContent || '{}') || {};
      } catch (error) {
        config = {};
      }
    }

    var sectionId = config.sectionId || root.getAttribute('data-turf-calculator-section-id') || root.id.replace(/^TurfCalculator-/, '');

    return {
      sectionId: sectionId || 'default',
      shapeInputName: config.shapeInputName || ('shape-' + sectionId),
      priorityInputName: config.priorityInputName || ('priority-' + sectionId),
      accessories: Array.isArray(config.accessories) ? config.accessories : [],
      copy: config.copy || {}
    };
  }

  function initCalculator(root) {
    if (!root || root.dataset.turfCalculatorInitialized === 'true') return;

    var TurfCore = window.ATUTurfOrdering;
    if (!TurfCore) return;

    var calculatorConfig = readCalculatorConfig(root);

    var rollWidth = Number(root.dataset.rollWidth || TurfCore.DEFAULTS.ROLL_WIDTH_FT);
    var maxLength = Number(root.dataset.maxLength || TurfCore.DEFAULTS.MAX_ROLL_LENGTH_FT);
    var roundTo = Number(root.dataset.roundTo || 1);
    var bufferRate = 0;

    var modeInputs = root.querySelectorAll('[data-calculator-mode]');
    var quickPanel = root.querySelector('[data-quick-panel]');
    var detailPanel = root.querySelector('[data-detail-panel]');
    var simpleAreaInput = root.querySelector('[data-simple-area]');
    var lengthInput = root.querySelector('[data-length]');
    var widthInput = root.querySelector('[data-width]');
    var projectAreaInput = root.querySelector('[data-project-area]');
    var keepDirectionInput = root.querySelector('[data-keep-direction]');
    var shapeInputs = root.querySelectorAll('input[name="' + calculatorConfig.shapeInputName + '"]');
    var priorityField = root.querySelector('[data-priority-field]');
    var priorityInputs = root.querySelectorAll('input[name="' + calculatorConfig.priorityInputName + '"]');
    var priorityNote = root.querySelector('[data-priority-note]');
    var guideTitle = root.querySelector('[data-guide-title]');
    var guideList = root.querySelector('[data-guide-list]');
    var shapeNote = root.querySelector('[data-measure-note]');
    var lengthLabel = root.querySelector('[data-length-label]');
    var widthLabel = root.querySelector('[data-width-label]');
    var diagramBox = root.querySelector('[data-diagram-box]');
    var diagramShape = root.querySelector('[data-diagram-shape]');
    var diagramNear = root.querySelector('[data-diagram-near]');
    var diagramFar = root.querySelector('[data-diagram-far]');
    var diagramDirection = root.querySelector('[data-diagram-direction]');
    var cutPlanScene = root.querySelector('[data-cut-plan-scene]');
    var cutPlanBoard = root.querySelector('[data-cut-plan-board]');
    var cutHouse = root.querySelector('[data-cut-house]');
    var cutTarget = root.querySelector('[data-cut-target]');
    var cutArrowLabel = root.querySelector('[data-cut-arrow-label]');
    var cutPlanRoll = root.querySelector('[data-cut-plan-roll]');
    var cutPlanNote = root.querySelector('[data-cut-plan-note]');
    var orderSummary = root.querySelector('[data-order-summary]');
    var measuredArea = root.querySelector('[data-measured-area]');
    var bufferArea = root.querySelector('[data-buffer-area]');
    var requiredArea = root.querySelector('[data-required-area]');
    var orderArea = root.querySelector('[data-order-area]');
    var layoutSummary = root.querySelector('[data-layout-summary]');
    var wasteArea = root.querySelector('[data-waste-area]');
    var rollBreakdown = root.querySelector('[data-roll-breakdown]');
    var alternateLayout = root.querySelector('[data-alternate-layout]');
    var directionCheck = root.querySelector('[data-direction-check]');
    var copyButton = root.querySelector('[data-copy-note]');
    var quoteMessage = root.querySelector('[data-quote-message]');
    var productCta = root.querySelector('[data-product-cta]');
    var productCtaTitle = root.querySelector('[data-product-cta-title]');
    var productLoadingTitle = productCtaTitle ? productCtaTitle.textContent : '';
    var productCtaDetail = root.querySelector('[data-product-cta-detail]');
    var productAddButton = root.querySelector('[data-product-add]');
    var productViewLink = root.querySelector('[data-product-view]');
    var productCartLink = root.querySelector('[data-product-cart]');
    var productStatus = root.querySelector('[data-product-status]');
    var accessorySection = root.querySelector('[data-calculator-accessories]');
    var accessoryList = root.querySelector('[data-accessory-list]');
    var accessoryNote = root.querySelector('[data-accessory-note]');
    var accessorySubtotal = root.querySelector('[data-accessory-subtotal]');
    var accessorySelectAll = root.querySelector('[data-accessory-select-all]');
    var turfChoices = root.querySelector('[data-turf-choices]');
    var productChoiceLinks = root.querySelectorAll('[data-product-choice]');
    var projectChoiceLinks = root.querySelectorAll('[data-calculator-project-link]');

    if (!modeInputs.length || !lengthInput || !widthInput || !copyButton || !orderSummary || !measuredArea || !orderArea || !layoutSummary || !rollBreakdown) {
      return;
    }

    root.dataset.turfCalculatorInitialized = 'true';

    var urlParams = new URLSearchParams(window.location.search);
    var sourceProductHandle = (urlParams.get('product') || urlParams.get('product_handle') || '').trim();
    var sourceProduct = null;
    var sourceProductPromise = null;
    var sourceProductLoaded = false;
    var currentLayout = null;
    var currentCartItems = [];
    var calculatorStateStorageKey = 'turfCalculatorState';
    var calculatorAccessories = (calculatorConfig.accessories || []).filter(function(accessory) {
      return accessory && accessory.variant && accessory.variant.available;
    });

    var guides = {
      rectangle: {
        title: 'How to measure a rectangle',
        note: 'Measure the full outside rectangle.',
        steps: [
          'Side 1 is the edge that runs along the house, street, or reference side.',
          'Side 2 is the depth between the reference edge and the target/view side.',
          'The calculator uses Side 2 as the piece length so the blade direction stays consistent.'
        ]
      },
      square: {
        title: 'How to measure a square',
        note: 'Measure one side, then enter the same number for Side 1 and Side 2.',
        steps: [
          'Measure one outside side of the square.',
          'Enter the same number for Side 1 and Side 2.',
          calculatorConfig.copy.wholeFootNote
        ]
      },
      circle: {
        title: 'How to measure a circle',
        note: 'Use the outside square around the circle. Measure the diameter at the widest point.',
        steps: [
          'Measure straight across the circle at the widest point.',
          'Enter that diameter for Side 1 and Side 2.',
          'The corners of the square become trimming waste, but you will have enough turf.'
        ]
      },
      oval: {
        title: 'How to measure an oval',
        note: 'Use the outside rectangle around the oval, not the oval math area.',
        steps: [
          'Measure Side 1 along the house, street, or reference edge.',
          'Measure Side 2 along the blade-direction depth.',
          'Order the full outside rectangle so curved edges can be cut on site.'
        ]
      },
      triangle: {
        title: 'How to measure a triangle',
        note: 'Use the outside rectangle that covers the full triangle. Do not order only the triangle formula area.',
        steps: [
          'Measure Side 1 along the reference edge of the outside box.',
          'Measure Side 2 as the straight depth between that edge and the target/view side.',
          'Order the full rectangle, then trim the angled sides during installation.'
        ]
      },
      trapezoid: {
        title: 'How to measure a trapezoid',
        note: 'Measure the longer parallel side and the full height/depth. The short side does not decide the roll size.',
        steps: [
          'Use the longer parallel side as Side 1 when it runs along the reference edge.',
          'Measure Side 2 as the straight depth between the reference edge and the target/view side.',
          'Order the outside rectangle and trim both angled sides.'
        ]
      },
      lshape: {
        title: 'How to measure an L-shaped yard',
        note: 'For the least waste, split the L into two rectangles and run this calculator once for each rectangle.',
        steps: [
          'Best method: split the L into Rectangle A and Rectangle B.',
          'For each rectangle, enter Side 1 along the reference edge and Side 2 along the blade-direction depth.',
          'If you want the fastest estimate, enter the full outside rectangle, but it will include more waste.'
        ]
      },
      curved: {
        title: 'How to measure curved or kidney shapes',
        note: 'For curved, kidney, S-curve, or odd corners, use the full outside rectangle.',
        steps: [
          'Mark the outside box around the curve.',
          'Measure Side 1 along the reference edge and Side 2 along the blade-direction depth.',
          'Order enough for that rectangle, then trim the curve on site.'
        ]
      },
      multi: {
        title: 'How to measure multiple areas',
        note: 'Calculate each separate area one at a time. This avoids mixing measurements and helps keep seams cleaner.',
        steps: [
          'Start with Area 1 and enter its outside rectangle.',
          'Copy the order note, then repeat for Area 2, Area 3, and so on.',
          'Try to keep all rolls facing the same blade direction across the project.'
        ]
      }
    };

    function roundUp(value, increment) {
      return Math.ceil(value / increment) * increment;
    }

    function formatNumber(value) {
      return Math.round(value).toLocaleString();
    }

    function formatSqft(value) {
      var number = Number(value) || 0;

      return number.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }

    function formatMoney(cents) {
      var amount = (Number(cents) || 0) / 100;

      return amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[character];
      });
    }

    function integerValue(value) {
      return Math.max(0, parseInt(value, 10) || 0);
    }

    function formatFeet(value) {
      var rounded = Math.round(value * 10) / 10;
      return rounded.toLocaleString(undefined, {
        maximumFractionDigits: rounded % 1 === 0 ? 0 : 1
      });
    }

    function rollSizeLabel(length) {
      return '15 ft x ' + formatFeet(length) + ' ft';
    }

    function missingVariantMessage(length) {
      return '15 x ' + formatFeet(length) + ' variant is missing for this product. Please contact us or choose another product.';
    }

    function productBaseUrl() {
      return sourceProductHandle ? '/products/' + encodeURIComponent(sourceProductHandle) : '/collections/all-turf-products';
    }

    function productUrl(variantId) {
      var extraParams = {};

      if (variantId) {
        extraParams.variant = variantId;
      }

      return sourceProductHandle ? urlWithCalculatorState(productBaseUrl(), extraParams) : productBaseUrl();
    }

    function setRadioValue(inputs, value) {
      if (!value) return;

      inputs.forEach(function(input) {
        input.checked = input.value === value;
      });
    }

    function selectedCalculatorMode() {
      var checked = root.querySelector('[data-calculator-mode]:checked');
      return checked ? checked.value : 'quick';
    }

    function setCalculatorMode(mode) {
      var nextMode = mode === 'detail' ? 'detail' : 'quick';

      setRadioValue(modeInputs, nextMode);
      if (quickPanel) quickPanel.hidden = nextMode !== 'quick';
      if (detailPanel) detailPanel.hidden = nextMode !== 'detail';
      root.setAttribute('data-mode', nextMode);
    }

    function applyUrlState() {
      var side1 = urlParams.get('side1') || urlParams.get('length');
      var side2 = urlParams.get('side2') || urlParams.get('width');
      var shape = urlParams.get('shape');
      var projectArea = urlParams.get('project_area');
      var keepDirection = urlParams.get('keep_direction');
      var priority = urlParams.get('priority');
      var mode = urlParams.get('mode');
      var sqft = urlParams.get('sqft') || urlParams.get('area');

      if (!mode && side1 && side2) {
        mode = 'detail';
      }

      setCalculatorMode(mode || 'quick');

      if (side1 && Number(side1) > 0) lengthInput.value = side1;
      if (side2 && Number(side2) > 0) widthInput.value = side2;
      if (simpleAreaInput && sqft && Number(sqft) > 0) simpleAreaInput.value = sqft;
      setRadioValue(shapeInputs, shape);
      setRadioValue(priorityInputs, priority);

      if (projectAreaInput && projectArea && Array.prototype.some.call(projectAreaInput.options, function(option) {
        return option.value === projectArea;
      })) {
        projectAreaInput.value = projectArea;
      }

      if (keepDirectionInput && keepDirection !== null) {
        keepDirectionInput.checked = keepDirection !== '0' && keepDirection !== 'false';
      }
    }

    function calculatorStateParams() {
      var params = new URLSearchParams();
      var mode = selectedCalculatorMode();

      params.set('mode', mode);

      if (mode === 'quick') {
        params.set('sqft', simpleAreaInput && simpleAreaInput.value ? simpleAreaInput.value : '0');
        return params;
      }

      params.set('shape', selectedShape());
      params.set('side1', lengthInput.value || '0');
      params.set('side2', widthInput.value || '0');
      params.set('project_area', selectedProjectArea());
      params.set('keep_direction', keepDirectionConsistent() ? '1' : '0');

      if (orderPriorityAvailable(selectedShape())) {
        params.set('priority', selectedOrderPriority());
      }

      return params;
    }

    function hasCalculatorMeasurements(params) {
      if ((params.get('mode') || 'quick') === 'quick') {
        return Number(params.get('sqft') || params.get('area')) > 0;
      }

      return Number(params.get('side1') || params.get('length')) > 0 && Number(params.get('side2') || params.get('width')) > 0;
    }

    function persistCalculatorState(params) {
      if (!hasCalculatorMeasurements(params)) return;

      try {
        window.sessionStorage.setItem(calculatorStateStorageKey, params.toString());
      } catch (error) {
        // Storage can be blocked in some browser modes; links still carry the state.
      }
    }

    function baseHref(link) {
      if (!link.dataset.calculatorBaseHref) {
        link.dataset.calculatorBaseHref = link.getAttribute('href') || '';
      }

      return link.dataset.calculatorBaseHref;
    }

    function urlWithCalculatorState(href, extraParams) {
      var params = calculatorStateParams();
      var hasMeasurements = hasCalculatorMeasurements(params);
      var hasExtraParams = Boolean(extraParams && Object.keys(extraParams).length);

      if (hasMeasurements) {
        persistCalculatorState(params);
      }

      if (!hasMeasurements && !hasExtraParams) return href;

      var url = new URL(href, window.location.origin);
      if (hasMeasurements) {
        params.forEach(function(value, key) {
          if (value !== '') url.searchParams.set(key, value);
        });
      }

      if (extraParams) {
        Object.keys(extraParams).forEach(function(key) {
          url.searchParams.set(key, extraParams[key]);
        });
      }

      return url.pathname + (url.search ? url.search : '') + url.hash;
    }

    function calculatorUrlForProduct(handle) {
      return urlWithCalculatorState('/pages/turf-calculator?view=turf-calculator', {
        source: 'product',
        product: handle
      });
    }

    function updateCalculatorStateLinks() {
      productChoiceLinks.forEach(function(link) {
        var handle = link.dataset.productChoice;
        if (!handle) return;
        link.href = calculatorUrlForProduct(handle);
      });

      projectChoiceLinks.forEach(function(link) {
        link.href = urlWithCalculatorState(baseHref(link));
      });
    }

    function selectSourceProduct(handle) {
      if (!handle) return;

      sourceProductHandle = handle;
      sourceProduct = null;
      sourceProductPromise = null;
      sourceProductLoaded = false;
      currentCartItems = [];

      if (productCartLink) productCartLink.hidden = true;
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', calculatorUrlForProduct(handle));
      }

      setNextStepMode();
      updateProductCta(currentLayout);
    }

    function setNextStepMode() {
      var hasProductContext = Boolean(sourceProductHandle);

      if (productCta) productCta.hidden = !hasProductContext;
      if (turfChoices) turfChoices.hidden = hasProductContext;
      if (productViewLink) productViewLink.href = productUrl();

      if (hasProductContext) {
        loadSourceProduct();
      }
    }

    function loadSourceProduct() {
      if (!sourceProductHandle) return Promise.resolve(null);
      if (sourceProductPromise) return sourceProductPromise;

      if (productCtaTitle) productCtaTitle.textContent = productLoadingTitle;
      if (productStatus) productStatus.textContent = 'Loading this turf product...';

      sourceProductPromise = fetch(productBaseUrl() + '.js', {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Product could not be loaded.');
          return response.json();
        })
        .then(function(product) {
          sourceProduct = product;
          sourceProductLoaded = true;
          if (productCtaTitle) productCtaTitle.textContent = product.title;
          calculate();
          return product;
        })
        .catch(function() {
          sourceProductLoaded = true;
          sourceProduct = null;
          if (productStatus) productStatus.textContent = 'We could not load this product. Use View product or send measurements for a quote.';
          updateProductCta(currentLayout);
          return null;
        });

      return sourceProductPromise;
    }

    function findVariantForLength(product, length) {
      return TurfCore.findExactVariantForCut(product, rollWidth, length, {
        rollWidthFt: rollWidth,
        maxRollLengthFt: maxLength
      });
    }

    function currentProjectSqft() {
      if (selectedCalculatorMode() === 'quick') return Math.ceil(simpleProjectArea());
      return Math.ceil(Math.max(0, Number(lengthInput.value) * Number(widthInput.value)));
    }

    function estimatedSeamLinearFt(layout) {
      if (!layout || selectedCalculatorMode() === 'quick') return 0;

      var longSeamFt = 0;
      var shortSeamFt = 0;
      var runLength = Number(layout.rawLinearFeet) || 0;

      if (layout.cutSectionLengths && layout.cutSectionLengths.length) {
        runLength = Math.max.apply(null, layout.cutSectionLengths);
      }

      if (layout.longSeams && runLength) {
        longSeamFt = Number(layout.longSeams) * runLength;
      }

      if (layout.shortSeams) {
        shortSeamFt = Number(layout.shortSeams) * rollWidth;
      }

      if (!longSeamFt && !shortSeamFt && layout.rolls && layout.rolls.length > 1) {
        longSeamFt = Math.max(0, layout.rolls.length - 1) * rollWidth;
      }

      return Math.ceil(Math.max(0, longSeamFt + shortSeamFt));
    }

    function accessoryState(layout) {
      return {
        projectSqft: currentProjectSqft(),
        seamLinearFt: estimatedSeamLinearFt(layout)
      };
    }

    function recommendedAccessoryQuantity(accessory, state) {
      if (!accessory || !state || state.projectSqft <= 0) return 0;

      return TurfCore.recommendedSupplyQuantity(accessory, state);
    }

    function accessoryByKey(key) {
      return calculatorAccessories.find(function(accessory) {
        return accessory.key === key;
      });
    }

    function renderAccessories() {
      if (!accessorySection || !accessoryList) return;

      if (!calculatorAccessories.length) {
        accessorySection.hidden = true;
        return;
      }

      accessoryList.innerHTML = calculatorAccessories.map(function(accessory, index) {
        var id = 'calculator-accessory-' + accessory.key + '-' + index + '-' + calculatorConfig.sectionId;
        var qtyId = id + '-qty';
        var image = accessory.product && accessory.product.image
          ? '<img src="' + escapeHtml(accessory.product.image) + '" alt="" loading="lazy" decoding="async">'
          : '';

        return [
          '<div class="turf-calculator__accessory" data-accessory-row data-key="' + escapeHtml(accessory.key) + '">',
            '<label class="turf-calculator__accessory-check" for="' + id + '">',
              '<input id="' + id + '" type="checkbox" data-accessory-check>',
            '</label>',
            '<div class="turf-calculator__accessory-image">' + image + '</div>',
            '<div class="turf-calculator__accessory-main">',
              '<strong>' + escapeHtml(accessory.label) + '</strong>',
              '<span>' + escapeHtml(accessory.rule) + '</span>',
            '</div>',
            '<div class="turf-calculator__accessory-qty">',
              '<button type="button" data-accessory-decrease aria-label="Decrease ' + escapeHtml(accessory.label) + '">-</button>',
              '<input id="' + qtyId + '" type="text" inputmode="numeric" autocomplete="off" value="0" data-accessory-qty aria-label="' + escapeHtml(accessory.label) + ' quantity">',
              '<button type="button" data-accessory-increase aria-label="Increase ' + escapeHtml(accessory.label) + '">+</button>',
            '</div>',
            '<strong class="turf-calculator__accessory-price" data-accessory-price>$0.00</strong>',
          '</div>'
        ].join('');
      }).join('');
    }

    function updateAccessorySubtotal() {
      var total = selectedAccessoryRows().reduce(function(sum, item) {
        return sum + (Number(item.accessory.variant.price) || 0) * item.quantity;
      }, 0);

      if (accessorySubtotal) accessorySubtotal.textContent = formatMoney(total);
      return total;
    }

    function updateAccessories(layout) {
      if (!accessorySection || !accessoryList || !sourceProductHandle || !calculatorAccessories.length) {
        if (accessorySection) accessorySection.hidden = true;
        return;
      }

      var state = accessoryState(layout);
      var hasProject = state.projectSqft > 0;
      accessorySection.hidden = false;

      Array.prototype.forEach.call(accessoryList.querySelectorAll('[data-accessory-row]'), function(row) {
        var accessory = accessoryByKey(row.getAttribute('data-key'));
        var input = row.querySelector('[data-accessory-qty]');
        var check = row.querySelector('[data-accessory-check]');
        var price = row.querySelector('[data-accessory-price]');
        var recommended = recommendedAccessoryQuantity(accessory, state);

        if (!accessory || !input || !check || !price) return;

        if (input.dataset.manual !== 'true') {
          input.value = String(recommended);
        }

        if (check.dataset.manual !== 'true') {
          check.checked = Boolean(accessory.defaultSelected && recommended > 0);
        }

        price.textContent = formatMoney((Number(accessory.variant.price) || 0) * integerValue(input.value));
      });

      if (accessoryNote) {
        accessoryNote.textContent = hasProject
          ? 'Qty auto-calculated for your ' + formatNumber(state.projectSqft) + ' sq ft project' + (state.seamLinearFt > 0 ? ' and about ' + formatNumber(state.seamLinearFt) + ' seam ft.' : '.')
          : 'Enter a project size to auto-calculate install supplies.';
      }

      updateAccessorySubtotal();
    }

    function selectedAccessoryRows() {
      if (!accessoryList) return [];

      return Array.prototype.slice.call(accessoryList.querySelectorAll('[data-accessory-row]')).map(function(row) {
        var accessory = accessoryByKey(row.getAttribute('data-key'));
        var check = row.querySelector('[data-accessory-check]');
        var input = row.querySelector('[data-accessory-qty]');
        var quantity = integerValue(input ? input.value : 0);

        return check && check.checked && accessory && quantity > 0 ? {
          accessory: accessory,
          quantity: quantity
        } : null;
      }).filter(Boolean);
    }

    function selectedAccessoryItems(layout) {
      var state = accessoryState(layout);

      return selectedAccessoryRows().map(function(item) {
        return {
          id: item.accessory.variant.id,
          quantity: item.quantity,
          properties: {
            'Recommended For': formatNumber(state.projectSqft) + ' sq ft turf project',
            'Recommended Quantity Rule': item.accessory.rule,
            'Estimated Seam Length': formatNumber(state.seamLinearFt) + ' ft',
            'Source': 'Turf Calculator'
          }
        };
      });
    }

    function bindAccessoryEvents() {
      if (accessoryList) {
        accessoryList.addEventListener('change', function(event) {
          if (!event.target.matches('[data-accessory-check]')) return;
          event.target.dataset.manual = 'true';
          updateAccessorySubtotal();
          updateProductCta(currentLayout);
        });

        accessoryList.addEventListener('input', function(event) {
          if (!event.target.matches('[data-accessory-qty]')) return;
          event.target.dataset.manual = 'true';
          event.target.value = String(integerValue(event.target.value));
          updateAccessories(currentLayout);
          updateProductCta(currentLayout);
        });

        accessoryList.addEventListener('click', function(event) {
          var row = event.target.closest('[data-accessory-row]');
          var input = row ? row.querySelector('[data-accessory-qty]') : null;
          var check = row ? row.querySelector('[data-accessory-check]') : null;
          var direction = event.target.matches('[data-accessory-increase]') ? 1 : event.target.matches('[data-accessory-decrease]') ? -1 : 0;

          if (!direction || !input) return;

          input.dataset.manual = 'true';
          input.value = String(Math.max(0, integerValue(input.value) + direction));

          if (check) {
            check.dataset.manual = 'true';
            check.checked = integerValue(input.value) > 0;
          }

          updateAccessories(currentLayout);
          updateProductCta(currentLayout);
        });
      }

      if (accessorySelectAll) {
        accessorySelectAll.addEventListener('click', function() {
          var state = accessoryState(currentLayout);

          Array.prototype.forEach.call(accessoryList ? accessoryList.querySelectorAll('[data-accessory-row]') : [], function(row) {
            var accessory = accessoryByKey(row.getAttribute('data-key'));
            var input = row.querySelector('[data-accessory-qty]');
            var check = row.querySelector('[data-accessory-check]');
            var recommended = recommendedAccessoryQuantity(accessory, state);

            if (input) {
              input.dataset.manual = 'true';
              input.value = String(Math.max(1, recommended));
            }

            if (check) {
              check.dataset.manual = 'true';
              check.checked = true;
            }
          });

          updateAccessories(currentLayout);
          updateProductCta(currentLayout);
        });
      }
    }

    function cartProperties() {
      var state = accessoryState(currentLayout);

      if (selectedCalculatorMode() === 'quick') {
        return {
          'Project Sq Ft': simpleAreaInput ? simpleAreaInput.value : '',
          'Recommended Roll': orderSummary ? orderSummary.textContent : '',
          'Estimated Seam Length': formatNumber(state.seamLinearFt) + ' ft',
          'Cut Notes': rollBreakdown ? rollBreakdown.textContent : '',
          'Source': 'Turf Calculator',
          'Calculator Mode': 'Quick sqft'
        };
      }

      return {
        'Calculator recommendation': orderSummary ? orderSummary.textContent : '',
        'Measurements': 'Side 1 ' + lengthInput.value + ' ft x Side 2 ' + widthInput.value + ' ft',
        'Project area': selectedProjectAreaLabel(),
        'Cut plan': cutPlanSummary(),
        'Estimated Seam Length': formatNumber(state.seamLinearFt) + ' ft',
        'Source': 'Turf Calculator',
        'Calculator Mode': 'Detailed layout'
      };
    }

    function buildCartItems(layout) {
      var result = {
        items: [],
        missing: [],
        unavailable: []
      };

      if (!sourceProduct || !layout || !layout.rolls || !layout.rolls.length) return result;

      var grouped = {};
      layout.rolls.forEach(function(length) {
        var variant = findVariantForLength(sourceProduct, length);

        if (!variant) {
          result.missing.push(length);
          return;
        }

        if (!variant.available) {
          result.unavailable.push(length);
          return;
        }

        if (!grouped[variant.id]) {
          grouped[variant.id] = {
            id: variant.id,
            quantity: 0,
            properties: cartProperties()
          };
        }

        grouped[variant.id].quantity += 1;
      });

      result.items = Object.keys(grouped).map(function(id) {
        return grouped[id];
      });

      return result;
    }

    function updateProductCta(layout) {
      if (!productCta) return;

      if (!sourceProductHandle) {
        updateAccessories(null);
        return;
      }

      var rolls = layout && layout.rolls ? layout.rolls : [];
      var sizeText = rolls.length
        ? rolls.map(rollSizeLabel).join(' + ')
        : 'Waiting for measurements';
      var cartPlan = sourceProduct && layout ? buildCartItems(layout) : {
        items: [],
        missing: [],
        unavailable: []
      };
      var firstItem = cartPlan.items.length ? cartPlan.items[0] : null;
      var accessoryItems = [];

      updateAccessories(layout);
      accessoryItems = selectedAccessoryItems(layout);

      if (productViewLink) {
        productViewLink.href = productUrl(firstItem && firstItem.id);
      }

      if (productCtaDetail) {
        productCtaDetail.textContent = 'Recommended exact size for this product: ' + sizeText + '.';
      }

      if (!sourceProductLoaded) {
        currentCartItems = [];
        if (productAddButton) productAddButton.disabled = true;
        if (productStatus) productStatus.textContent = 'Loading this turf product...';
        return;
      }

      if (!sourceProduct) {
        currentCartItems = [];
        if (productAddButton) productAddButton.disabled = true;
        return;
      }

      currentCartItems = cartPlan.items.concat(accessoryItems);

      if (productCtaTitle) productCtaTitle.textContent = sourceProduct.title;

      if (!layout || !rolls.length) {
        if (productAddButton) productAddButton.disabled = true;
        if (productStatus) productStatus.textContent = 'Enter measurements to match a roll size.';
        return;
      }

      if (cartPlan.missing.length || cartPlan.unavailable.length) {
        if (productAddButton) productAddButton.disabled = true;
        if (productStatus) {
          var problemLength = cartPlan.missing[0] || cartPlan.unavailable[0];
          productStatus.textContent = missingVariantMessage(problemLength);
        }
        return;
      }

      if (productAddButton) {
        productAddButton.disabled = false;
        productAddButton.textContent = 'Add Turf Package to Cart';
      }

      if (productStatus) {
        productStatus.textContent = 'Ready to add ' + sizeText + ' of ' + sourceProduct.title + (accessoryItems.length ? ' with selected install supplies.' : '.');
      }
    }

    function cartItemQuantity(items) {
      return (items || []).reduce(function(total, item) {
        return total + Math.max(1, Number(item && item.quantity) || 1);
      }, 0);
    }

    function currentHeaderCartCount() {
      var themeCount = window.theme && Number(window.theme.cartCount);

      if (Number.isFinite(themeCount)) {
        return themeCount;
      }

      var counter = document.querySelector('.header__cart-count');
      var parsed = counter ? Number((counter.textContent || '').trim()) : 0;

      return Number.isFinite(parsed) ? parsed : 0;
    }

    function updateHeaderCartCount(count) {
      if (!Number.isFinite(count)) return;

      document.querySelectorAll('.header__cart-count').forEach(function(counter) {
        counter.textContent = count;
      });

      if (window.theme) {
        window.theme.cartCount = count;
      }
    }

    function refreshCartCountFromShopify(expectedMinimum) {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart refresh failed.');
          return response.json();
        })
        .then(function(cart) {
          var itemCount = Number(cart && cart.item_count);

          if (Number.isFinite(expectedMinimum)) {
            itemCount = Math.max(itemCount, expectedMinimum);
          }

          updateHeaderCartCount(itemCount);
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              cart: cart
            }
          }));
        })
        .catch(function() {});
    }

    function notifyCartAdded(items) {
      var quantity = cartItemQuantity(items);
      var expectedCount = currentHeaderCartCount() + quantity;

      updateHeaderCartCount(expectedCount);

      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: null,
          button: productAddButton,
          quantity: quantity
        }
      }));

      refreshCartCountFromShopify(expectedCount);
      [500, 1500, 3000].forEach(function(delay) {
        window.setTimeout(function() {
          refreshCartCountFromShopify(expectedCount);
        }, delay);
      });
    }

    function addRecommendedProduct() {
      if (!productAddButton || productAddButton.disabled) return;

      calculate();

      if (!sourceProductLoaded) {
        productAddButton.disabled = true;
        if (productStatus) productStatus.textContent = 'Loading this turf product...';
        loadSourceProduct().then(function() {
          updateProductCta(currentLayout);
        });
        return;
      }

      var cartPlan = buildCartItems(currentLayout);
      currentCartItems = cartPlan.items.concat(selectedAccessoryItems(currentLayout));

      if (cartPlan.missing.length || cartPlan.unavailable.length || !cartPlan.items.length) {
        productAddButton.disabled = true;
        if (productStatus) {
          var problemLength = cartPlan.missing[0] || cartPlan.unavailable[0];
          productStatus.textContent = problemLength ? missingVariantMessage(problemLength) : 'This product does not have the current recommended roll size available. Please contact us or choose another product.';
        }
        return;
      }

      productAddButton.disabled = true;
      productAddButton.textContent = 'Adding...';
      if (productStatus) productStatus.textContent = 'Adding turf package to cart...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: currentCartItems
        })
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart add failed.');
          return response.json();
        })
        .then(function() {
          notifyCartAdded(currentCartItems);
          productAddButton.textContent = 'Added to cart';
          if (productCartLink) productCartLink.hidden = false;
          if (productStatus) productStatus.textContent = 'Added. You can review the cart or keep editing the measurements.';
        })
        .catch(function() {
          productAddButton.disabled = false;
          productAddButton.textContent = 'Add Turf Package to Cart';
          if (productStatus) productStatus.textContent = 'Could not add automatically. Open the product page or send measurements for a quote.';
        });
    }

    function selectedShape() {
      var checked = root.querySelector('input[name="' + calculatorConfig.shapeInputName + '"]:checked');
      return checked ? checked.value : 'rectangle';
    }

    function shapeSupportsOrderPriority(shape) {
      return shape === 'rectangle' || shape === 'square';
    }

    function selectedOrderPriority() {
      var checked = root.querySelector('input[name="' + calculatorConfig.priorityInputName + '"]:checked');
      return checked ? checked.value : 'seams';
    }

    function selectedProjectArea() {
      return projectAreaInput ? projectAreaInput.value : 'front';
    }

    function selectedProjectAreaLabel() {
      if (!projectAreaInput) return 'Front yard - blades face the street';
      return projectAreaInput.options[projectAreaInput.selectedIndex].text;
    }

    function keepDirectionConsistent() {
      return !keepDirectionInput || keepDirectionInput.checked;
    }

    function orderPriorityAvailable(shape) {
      return shapeSupportsOrderPriority(shape) && keepDirectionConsistent();
    }

    function updatePriorityControl(shape) {
      if (!priorityField) return;

      var available = orderPriorityAvailable(shape);
      priorityField.hidden = !available;

      if (!priorityNote) return;

      if (!shapeSupportsOrderPriority(shape)) {
        priorityNote.textContent = 'Seam and waste priority is only available for rectangle and square yards.';
      } else if (!keepDirectionConsistent()) {
        priorityNote.textContent = 'Turn on blade direction consistency to compare seam and waste options.';
      } else {
        priorityNote.textContent = 'Minimize waste can save material when the leftover width can be cut into multiple shorter filler pieces.';
      }
    }

    function rollReferenceText() {
      return 'Original roll: 15 ft x 100 ft. Blade direction runs toward the 15 ft-wide end side.';
    }

    function directionContext() {
      if (!keepDirectionConsistent()) {
        return {
          mode: 'off',
          near: 'Reference edge',
          far: 'Main view',
          diagramDirection: 'Direction unlocked',
          target: 'main view',
          side1Label: 'Side 1',
          side2Label: 'Side 2',
          sideGuide: 'Use the lower-waste orientation only when blade direction does not matter.'
        };
      }

      var area = selectedProjectArea();

      if (area === 'back') {
        return {
          mode: 'back',
          near: 'Back fence',
          far: 'House',
          diagramDirection: 'Blades face house',
          target: 'house',
          side1Label: 'Side 1 - along house/back edge',
          side2Label: 'Side 2 - back fence to house',
          sideGuide: 'Enter Side 1 along the house or back-fence edge, and Side 2 from the back fence toward the house.'
        };
      }

      if (area === 'other') {
        return {
          mode: 'other',
          near: 'Opposite edge',
          far: 'Main view',
          diagramDirection: 'Blades face main view',
          target: 'main view',
          side1Label: 'Side 1 - reference edge',
          side2Label: 'Side 2 - toward main view',
          sideGuide: 'Enter Side 1 along your reference edge, and Side 2 along the depth that should face the main view.'
        };
      }

      return {
        mode: 'front',
        near: 'House',
        far: 'Street',
        diagramDirection: 'Blades face street',
        target: 'street',
        side1Label: 'Side 1 - parallel to street',
        side2Label: 'Side 2 - street to house',
        sideGuide: 'Enter Side 1 along the street-facing edge, and Side 2 from the street toward the house. The cut plan keeps the blade direction facing back toward the street.'
      };
    }

    function updateMeasurementDiagram(length, width, shape) {
      if (!diagramBox) return;

      if (!length || !width) {
        diagramBox.style.width = '';
        diagramBox.style.aspectRatio = '';
        return;
      }

      var displayRatio = length / width;
      if (shape === 'square' || shape === 'circle') {
        displayRatio = 1;
      }

      displayRatio = Math.max(.55, Math.min(2.8, displayRatio));

      var maxBoxWidth = shape === 'square' || shape === 'circle' ? 430 : 520;
      var maxBoxHeight = shape === 'square' || shape === 'circle' ? 430 : 360;
      var drawWidth = maxBoxWidth;
      var drawHeight = drawWidth / displayRatio;

      if (drawHeight > maxBoxHeight) {
        drawHeight = maxBoxHeight;
        drawWidth = drawHeight * displayRatio;
      }

      diagramBox.style.width = 'min(' + Math.round(drawWidth) + 'px, 90%)';
      diagramBox.style.aspectRatio = displayRatio.toFixed(3) + ' / 1';
    }

    function updateDiagramContext(shape) {
      var context = directionContext();

      if (lengthLabel) lengthLabel.textContent = context.side1Label;
      if (widthLabel) widthLabel.textContent = context.side2Label;
      if (diagramNear) diagramNear.textContent = context.near;
      if (diagramFar) diagramFar.textContent = context.far;
      if (diagramDirection) diagramDirection.textContent = context.diagramDirection;
      if (diagramBox) diagramBox.className = 'turf-calculator__diagram-box is-' + shape + ' is-area-' + context.mode;
    }

    function directionAdvice() {
      if (!keepDirectionConsistent()) {
        return {
          label: 'Direction consistency is off',
          detail: 'Only rotate pieces when appearance matters less than minimizing waste. Rotated pieces may show a different shade or sheen.'
        };
      }

      var area = selectedProjectArea();

      if (area === 'back') {
        return {
          label: 'Back yard direction: blades face the house',
          detail: 'For back yards, orient the 15 ft-wide end-side blade direction toward the main viewing area from the house.'
        };
      }

      if (area === 'other') {
        return {
          label: 'Direction plan: choose one main viewing direction',
          detail: 'For side yards or multiple areas, pick one reference direction before cutting and keep every 15 ft-wide end-side blade direction consistent.'
        };
      }

      return {
        label: 'Front yard direction: blades face the street',
        detail: 'For curb appeal, orient the 15 ft-wide end-side blade direction toward the street.'
      };
    }

    function targetDirectionLabel() {
      return directionContext().target;
    }

    function cutPlanInfo() {
      var length = Math.max(0, Number(lengthInput.value));
      var width = Math.max(0, Number(widthInput.value));
      if (!length || !width) return null;

      var runLength = width;
      var acrossWidth = length;
      var shape = selectedShape();
      var priority = orderPriorityAvailable(shape) ? selectedOrderPriority() : 'seams';
      var pieces = Math.max(1, Math.ceil(acrossWidth / rollWidth));
      var spareWidth = Math.max(0, pieces * rollWidth - acrossWidth);
      var lastUsedWidth = spareWidth > 0 ? rollWidth - spareWidth : rollWidth;

      if (priority === 'waste') {
        var fullStrips = Math.floor(acrossWidth / rollWidth);
        var remainingWidth = Math.max(0, acrossWidth - (fullStrips * rollWidth));
        var segmentsPerCut = remainingWidth > 0 ? Math.max(1, Math.floor(rollWidth / remainingWidth)) : 0;
        var fillerLength = remainingWidth > 0 ? Math.ceil(runLength / segmentsPerCut) : 0;
        var fillerPieces = remainingWidth > 0 ? Math.ceil(runLength / fillerLength) : 0;
        var fillerSpareWidth = remainingWidth > 0 ? Math.max(0, rollWidth - (segmentsPerCut * remainingWidth)) : 0;

        return {
          strategy: 'waste',
          runLength: runLength,
          acrossWidth: acrossWidth,
          pieces: fullStrips + (remainingWidth > 0 ? 1 : 0),
          fullStrips: fullStrips,
          remainingWidth: remainingWidth,
          segmentsPerCut: segmentsPerCut,
          fillerLength: fillerLength,
          fillerPieces: fillerPieces,
          fillerSpareWidth: fillerSpareWidth,
          spareWidth: remainingWidth > 0 && segmentsPerCut <= 1 ? rollWidth - remainingWidth : fillerSpareWidth,
          lastUsedWidth: remainingWidth || rollWidth
        };
      }

      return {
        strategy: 'seams',
        runLength: runLength,
        acrossWidth: acrossWidth,
        pieces: pieces,
        spareWidth: spareWidth,
        lastUsedWidth: lastUsedWidth
      };
    }

    function sumLinearFeet(lengths) {
      return lengths.reduce(function(total, length) {
        return total + length;
      }, 0);
    }

    function cutPlanSectionLengths(info) {
      if (!info) return [];

      if (info.strategy === 'waste') {
        var sections = [];

        for (var fullIndex = 0; fullIndex < info.fullStrips; fullIndex++) {
          sections.push(info.runLength);
        }

        if (info.remainingWidth > 0) {
          sections.push(info.fillerLength || info.runLength);
        }

        return sections.length ? sections : [info.runLength];
      }

      return Array.from({ length: info.pieces }, function() {
        return info.runLength;
      });
    }

    function cutPlanRawLinearFeet(info) {
      return sumLinearFeet(cutPlanSectionLengths(info));
    }

    function cutPlanOrderInfo(info) {
      var sectionLengths = cutPlanSectionLengths(info);
      var rawLinearFeet = sumLinearFeet(sectionLengths);
      var rolls = rollsForCutSections(sectionLengths);
      var actualLinearFeet = rolls.reduce(function(total, roll) { return total + roll; }, 0);

      return {
        rawLinearFeet: rawLinearFeet,
        rolls: rolls,
        actualLinearFeet: actualLinearFeet,
        extraLinearFeet: Math.max(0, actualLinearFeet - rawLinearFeet)
      };
    }

    function rollOrderText(rolls) {
      if (rolls.length === 1) {
        return 'one 15 ft x ' + formatFeet(rolls[0]) + ' ft roll';
      }

      var groups = [];
      rolls.forEach(function(length) {
        var existing = groups.find(function(group) {
          return group.length === length;
        });

        if (existing) {
          existing.count += 1;
        } else {
          groups.push({ length: length, count: 1 });
        }
      });

      return rolls.length + ' rolls: ' + groups.map(function(group) {
        var size = '15 ft x ' + formatFeet(group.length) + ' ft';
        return group.count > 1 ? group.count + ' x ' + size : size;
      }).join(' + ');
    }

    function orderPlanText(info) {
      var orderInfo = cutPlanOrderInfo(info);
      var message = 'Order plan: buy ' + rollOrderText(orderInfo.rolls) + '.';

      if (orderInfo.extraLinearFeet > 0) {
        message += ' This includes ' + formatFeet(orderInfo.extraLinearFeet) + ' extra linear ft for roll-length rounding.';
      }

      return message;
    }

    function cutPlanSummary() {
      var info = cutPlanInfo();
      if (!info) return 'Order plan: waiting for measurements.';

      if (info.strategy === 'waste') {
        if (!info.remainingWidth) {
          return orderPlanText(info) + ' Job site cut plan: the 15 ft roll width fits this measurement evenly, so the waste-saving and seam-saving layouts are the same.';
        }

        var fullWord = info.fullStrips === 1 ? 'full strip' : 'full strips';
        var fullPhrase = info.fullStrips > 0
          ? 'cut ' + info.fullStrips + ' ' + fullWord + ' at 15 ft x ' + formatFeet(info.runLength) + ' ft, then '
          : '';

        if (info.segmentsPerCut > 1) {
          return orderPlanText(info) + ' Job site cut plan: ' + fullPhrase + 'cut ' + info.fillerPieces + ' filler pieces at ' + formatFeet(info.remainingWidth) + ' ft x ' + formatFeet(info.fillerLength) + ' ft from a 15 ft x ' + formatFeet(info.fillerLength) + ' ft section. This saves material but adds ' + Math.max(0, info.fillerPieces - 1) + ' short seams.';
        }

        return orderPlanText(info) + ' Job site cut plan: ' + fullPhrase + 'cut one ' + formatFeet(info.remainingWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft right-side strip. The remaining ' + formatFeet(info.spareWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft is spare material.';
      }

      if (info.pieces === 1) {
        if (info.spareWidth > 0) {
          return orderPlanText(info) + ' Job site cut plan: cut one ' + formatFeet(info.lastUsedWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft right-side strip. The remaining ' + formatFeet(info.spareWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft is spare material.';
        }

        return orderPlanText(info) + ' Job site cut plan: use one full 15 ft x ' + formatFeet(info.runLength) + ' ft piece.';
      }

      var pieceWord = info.pieces === 1 ? 'piece' : 'pieces';
      var summary = orderPlanText(info) + ' Job site cut plan: cut ' + info.pieces + ' ' + pieceWord + ' at 15 ft x ' + formatFeet(info.runLength) + ' ft';

      if (info.spareWidth > 0) {
        var fullPieces = info.pieces - 1;
        var finalPieceText = 'Piece ' + info.pieces;
        var fullPieceText = fullPieces === 1
          ? 'Use one full 15 ft x ' + formatFeet(info.runLength) + ' ft piece'
          : 'Use ' + fullPieces + ' full 15 ft x ' + formatFeet(info.runLength) + ' ft pieces';

        return summary + '. ' + fullPieceText + ', then cut a ' + formatFeet(info.lastUsedWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft right-side strip from ' + finalPieceText + '. The remaining ' + formatFeet(info.spareWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft is spare material.';
      }

      return summary + '. Use all pieces to fill the area.';
    }

    function createCutStrip(label, animationIndex, spareText, usedFr, spareFr, options) {
      options = options || {};

      var strip = document.createElement('div');
      strip.className = 'turf-calculator__cut-strip';
      strip.style.animationDelay = (animationIndex * 70) + 'ms';

      if (options.isFiller) {
        strip.classList.add('is-filler');
      }

      var used = document.createElement('span');
      used.className = 'turf-calculator__cut-strip-used';

      var usedLabel = document.createElement('span');
      usedLabel.className = 'turf-calculator__cut-strip-label';
      usedLabel.textContent = label;

      var arrowGroup = document.createElement('span');
      arrowGroup.className = 'turf-calculator__cut-strip-arrows';
      arrowGroup.setAttribute('aria-label', 'Grass blade direction');

      for (var arrowIndex = 0; arrowIndex < 3; arrowIndex++) {
        var usedArrow = document.createElement('span');
        usedArrow.className = 'turf-calculator__cut-strip-arrow';
        usedArrow.setAttribute('aria-hidden', 'true');
        arrowGroup.appendChild(usedArrow);
      }

      used.appendChild(usedLabel);
      used.appendChild(arrowGroup);

      if (options.segmentCount && options.segmentCount > 1) {
        strip.classList.add('has-seam-lines');

        var seams = document.createElement('span');
        seams.className = 'turf-calculator__cut-strip-seams';
        seams.setAttribute('aria-hidden', 'true');

        for (var seamIndex = 1; seamIndex < options.segmentCount; seamIndex++) {
          var seam = document.createElement('span');
          seam.className = 'turf-calculator__cut-strip-seam';
          seam.style.top = ((seamIndex / options.segmentCount) * 100).toFixed(2) + '%';
          seams.appendChild(seam);
        }

        used.appendChild(seams);
      }

      strip.appendChild(used);

      if (spareText) {
        strip.classList.add('has-spare');
        strip.style.gridTemplateColumns = Math.max(usedFr || 1, 1) + 'fr ' + Math.max(spareFr || 1, 1) + 'fr';

        var spare = document.createElement('span');
        spare.className = 'turf-calculator__cut-strip-spare';
        spare.textContent = spareText;
        strip.appendChild(spare);
      }

      return strip;
    }

    function updateCutPlan() {
      if (!cutPlanBoard || !cutPlanScene) return;

      var context = directionContext();
      var mode = context.mode;
      var info = cutPlanInfo();

      cutPlanScene.className = 'turf-calculator__cut-plan-scene is-' + mode;
      if (cutPlanRoll) cutPlanRoll.textContent = rollReferenceText();

      if (mode === 'back') {
        if (cutHouse) cutHouse.textContent = context.near;
        if (cutTarget) cutTarget.textContent = context.far;
        if (cutArrowLabel) cutArrowLabel.textContent = 'Grass blades face the house';
      } else if (mode === 'other') {
        if (cutHouse) cutHouse.textContent = context.near;
        if (cutTarget) cutTarget.textContent = context.far;
        if (cutArrowLabel) cutArrowLabel.textContent = 'Grass blades face the main view';
      } else if (mode === 'off') {
        if (cutHouse) cutHouse.textContent = context.near;
        if (cutTarget) cutTarget.textContent = context.far;
        if (cutArrowLabel) cutArrowLabel.textContent = 'Rotating cuts can change shade';
      } else {
        if (cutHouse) cutHouse.textContent = context.near;
        if (cutTarget) cutTarget.textContent = context.far;
        if (cutArrowLabel) cutArrowLabel.textContent = 'Grass blades face the street';
      }

      cutPlanBoard.textContent = '';

      if (!info) {
        cutPlanBoard.classList.add('is-empty');
        cutPlanBoard.textContent = 'Enter measurements to preview the cut plan.';
        if (cutPlanNote) cutPlanNote.textContent = 'Enter Side 1 and Side 2 using the landmarks shown on the outside box diagram.';
        return;
      }

      cutPlanBoard.classList.remove('is-empty');
      cutPlanBoard.style.gridTemplateRows = '';
      cutPlanBoard.style.gridTemplateColumns = 'repeat(' + info.pieces + ', minmax(84px, 1fr))';

      if (info.strategy === 'waste') {
        var wasteColumns = [];
        for (var columnIndex = 0; columnIndex < info.fullStrips; columnIndex++) {
          wasteColumns.push('minmax(84px, ' + rollWidth + 'fr)');
        }

        if (info.remainingWidth > 0) {
          var fillerColumnWidth = info.spareWidth > 0 ? rollWidth : info.remainingWidth;
          var fillerMinWidth = fillerColumnWidth < 8 ? 58 : 76;
          wasteColumns.push('minmax(' + fillerMinWidth + 'px, ' + fillerColumnWidth + 'fr)');
        }

        cutPlanBoard.style.gridTemplateColumns = wasteColumns.join(' ') || 'minmax(84px, 1fr)';

        for (var fullIndex = 1; fullIndex <= info.fullStrips; fullIndex++) {
          cutPlanBoard.appendChild(createCutStrip('Full strip ' + fullIndex + ': 15 ft x ' + formatFeet(info.runLength) + ' ft', fullIndex - 1));
        }

        if (info.remainingWidth > 0) {
          var fillerLabel = info.segmentsPerCut > 1
            ? info.fillerPieces + ' filler pieces\n' + formatFeet(info.remainingWidth) + ' ft x ' + formatFeet(info.fillerLength) + ' ft'
            : 'Filler piece\n' + formatFeet(info.remainingWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft';
          var fillerSpare = info.spareWidth > 0
            ? formatFeet(info.spareWidth) + ' ft wide offcut from filler cut'
            : '';

          cutPlanBoard.appendChild(createCutStrip(
            fillerLabel,
            info.fullStrips,
            fillerSpare,
            info.remainingWidth,
            info.spareWidth,
            {
              isFiller: true,
              segmentCount: info.fillerPieces
            }
          ));
        }

        if (cutPlanNote) {
          cutPlanNote.textContent = cutPlanSummary() + ' Keep every filler piece facing the ' + context.target + '.';
        }
        return;
      }

      for (var i = 1; i <= info.pieces; i++) {
        var stripLabel = 'Piece ' + i + ': use 15 ft x ' + formatFeet(info.runLength) + ' ft';

        if (i === info.pieces && info.spareWidth > 0) {
          stripLabel = 'Piece ' + i + ': use ' + formatFeet(info.lastUsedWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft right-side strip';
        }

        var strip = createCutStrip(stripLabel, i - 1);

        if (i === info.pieces && info.spareWidth > 0) {
          strip.classList.add('has-spare');
          strip.style.gridTemplateColumns = Math.max(info.lastUsedWidth, 1) + 'fr ' + info.spareWidth + 'fr';

          var spare = document.createElement('span');
          spare.className = 'turf-calculator__cut-strip-spare';
          spare.textContent = formatFeet(info.spareWidth) + ' ft x ' + formatFeet(info.runLength) + ' ft spare';
          strip.appendChild(spare);
        }

        cutPlanBoard.appendChild(strip);
      }

      if (cutPlanNote) {
        cutPlanNote.textContent = cutPlanSummary() + ' Keep all pieces facing the ' + context.target + ' so the blade direction stays consistent.';
      }
    }

    function updateDirectionCheck() {
      if (!directionCheck) return;

      if (selectedCalculatorMode() === 'quick') {
        directionCheck.textContent = '';

        var quickHeading = document.createElement('strong');
        quickHeading.textContent = 'Quick sqft estimate';

        var quickBody = document.createElement('span');
        quickBody.textContent = 'Use Detailed layout when the area is wider than 15 ft, has seams, or needs blade direction planning.';

        directionCheck.appendChild(quickHeading);
        directionCheck.appendChild(quickBody);
        return;
      }

      updateCutPlan();

      var advice = directionAdvice();
      directionCheck.textContent = '';

      var heading = document.createElement('strong');
      heading.textContent = advice.label;

      var body = document.createElement('span');
      body.textContent = advice.detail;

      directionCheck.appendChild(heading);
      directionCheck.appendChild(body);
    }

    function rollsForCutSections(sectionLengths) {
      return TurfCore.rollsForCutSections(sectionLengths, {
        maxRollLengthFt: maxLength,
        roundTo: roundTo
      });
    }

    function makeLayout(label, runLength, acrossWidth) {
      var strips = Math.ceil(acrossWidth / rollWidth);
      var cutSectionLengths = Array.from({ length: strips }, function() {
        return runLength;
      });
      var rawLinearFeet = sumLinearFeet(cutSectionLengths);
      return {
        label: label,
        priority: 'seams',
        strips: strips,
        longSeams: Math.max(0, strips - 1),
        shortSeams: 0,
        seams: Math.max(0, strips - 1),
        cutSectionLengths: cutSectionLengths,
        rawLinearFeet: rawLinearFeet
      };
    }

    function makeWasteLayout(label, runLength, acrossWidth) {
      var fullStrips = Math.floor(acrossWidth / rollWidth);
      var remainingWidth = Math.max(0, acrossWidth - (fullStrips * rollWidth));
      var widthSections = fullStrips + (remainingWidth > 0 ? 1 : 0);
      var segmentsPerCut = remainingWidth > 0 ? Math.max(1, Math.floor(rollWidth / remainingWidth)) : 0;
      var fillerLength = remainingWidth > 0 ? Math.ceil(runLength / segmentsPerCut) : 0;
      var fillerPieces = remainingWidth > 0 ? Math.ceil(runLength / fillerLength) : 0;
      var cutSectionLengths = [];

      for (var fullIndex = 0; fullIndex < fullStrips; fullIndex++) {
        cutSectionLengths.push(runLength);
      }

      if (remainingWidth > 0) {
        cutSectionLengths.push(fillerLength);
      }

      if (!cutSectionLengths.length) {
        cutSectionLengths.push(runLength);
      }

      var rawLinearFeet = sumLinearFeet(cutSectionLengths);

      return {
        label: label,
        priority: 'waste',
        strips: Math.max(1, widthSections),
        fullStrips: fullStrips,
        remainingWidth: remainingWidth,
        segmentsPerCut: segmentsPerCut,
        fillerLength: fillerLength,
        fillerPieces: fillerPieces,
        longSeams: Math.max(0, widthSections - 1),
        shortSeams: Math.max(0, fillerPieces - 1),
        seams: Math.max(0, widthSections - 1) + Math.max(0, fillerPieces - 1),
        cutSectionLengths: cutSectionLengths,
        rawLinearFeet: rawLinearFeet || runLength
      };
    }

    function completeLayout(layout, allowance, measuredArea) {
      layout.baseArea = layout.rawLinearFeet * rollWidth;
      layout.builtInOverageArea = Math.max(0, layout.baseArea - measuredArea);
      layout.builtInOverageRate = measuredArea > 0 ? layout.builtInOverageArea / measuredArea : 0;
      layout.selectedAllowance = allowance;
      layout.extraOverageBlocked = allowance > 0 && layout.builtInOverageRate >= .05;

      var extraOverageArea = 0;
      if (!layout.extraOverageBlocked) {
        extraOverageArea = Math.max(0, measuredArea * allowance - layout.builtInOverageArea);
      }

      layout.extraOverageArea = extraOverageArea;
      var orderSectionLengths = layout.cutSectionLengths ? layout.cutSectionLengths.slice() : [layout.rawLinearFeet];
      var extraLinearFeet = extraOverageArea / rollWidth;

      if (extraLinearFeet > 0) {
        orderSectionLengths.push(extraLinearFeet);
      }

      layout.orderLinearFeet = roundUp(sumLinearFeet(orderSectionLengths), roundTo);
      layout.rolls = rollsForCutSections(orderSectionLengths);
      layout.actualLinearFeet = layout.rolls.reduce(function(total, roll) { return total + roll; }, 0);
      layout.orderArea = layout.actualLinearFeet * rollWidth;
      layout.actualOverageArea = Math.max(0, layout.orderArea - measuredArea);
      layout.actualOverageRate = measuredArea > 0 ? layout.actualOverageArea / measuredArea : 0;
      layout.actualWasteArea = layout.actualOverageArea;
      return layout;
    }

    function quickWasteRate() {
      return bufferRate;
    }

    function simpleProjectArea() {
      return simpleAreaInput ? Math.max(0, Number(simpleAreaInput.value)) : 0;
    }

    function makeQuickLayout(projectArea) {
      var plan = TurfCore.calculateTurfCuts(projectArea, {
        rollWidthFt: rollWidth,
        maxRollLengthFt: maxLength,
        availableRollLengths: sourceProduct ? sourceProduct.variants.filter(function(variant) {
          return variant.available;
        }).map(function(variant) {
          return TurfCore.variantRollLength(variant, { rollWidthFt: rollWidth, maxRollLengthFt: maxLength });
        }).filter(Boolean) : undefined,
        bufferRate: quickWasteRate()
      });
      var rolls = plan.cuts.map(function(cut) {
        return cut.length;
      });

      return {
        error: plan.error,
        label: 'Quick sqft',
        priority: 'quick',
        strips: rolls.length,
        longSeams: 0,
        shortSeams: 0,
        seams: 0,
        rawLinearFeet: plan.requiredLinearFt,
        orderLinearFeet: plan.orderedSqft / rollWidth,
        actualLinearFeet: plan.orderedSqft / rollWidth,
        rolls: rolls,
        orderArea: plan.orderedSqft,
        actualWasteArea: plan.extraSqft,
        quickProjectArea: plan.measuredSqft,
        quickBufferArea: plan.bufferSqft,
        quickRequiredArea: plan.requiredSqft
      };
    }

    function makeDirectionLayout(length, width) {
      return makeLayout('Minimize seams', width, length);
    }

    function makeDirectionWasteLayout(length, width) {
      return makeWasteLayout('Minimize waste', width, length);
    }

    function makeRotatedLayout(length, width) {
      return makeLayout('Rotated layout', length, width);
    }

    function layoutOrderLabel(layout) {
      return layout.rolls.length === 1
        ? '15 ft x ' + layout.rolls[0] + ' ft'
        : layout.rolls.map(rollSizeLabel).join(' + ');
    }

    function layoutSeamText(layout) {
      var longText = layout.longSeams + (layout.longSeams === 1 ? ' long seam' : ' long seams');

      if (layout.shortSeams > 0) {
        return longText + ' + ' + layout.shortSeams + (layout.shortSeams === 1 ? ' short seam' : ' short seams');
      }

      return longText;
    }

    function layoutSummaryText(layout) {
      var sectionText = layout.strips + (layout.strips === 1 ? ' section' : ' sections');
      return sectionText + ', ' + layoutSeamText(layout);
    }

    function comparisonText(best, alternate) {
      var alternateName = alternate.priority === 'waste' ? 'Minimize waste option' : 'Minimize seams option';
      var difference = Math.round(alternate.orderArea - best.orderArea);
      var base = alternateName + ' order plan: buy ' + rollOrderText(alternate.rolls) + '; ' + layoutSeamText(alternate) + ', about ' + formatNumber(alternate.actualWasteArea) + ' sq ft waste/repair offcut.';

      if (difference === 0) {
        return base + ' For this measurement, both priorities need the same order size.';
      }

      if (difference > 0) {
        return base + ' That uses about ' + formatNumber(difference) + ' sq ft more material than the selected plan.';
      }

      return base + ' That saves about ' + formatNumber(Math.abs(difference)) + ' sq ft versus the selected plan, but may add short seams.';
    }

    function describeRolls(layout) {
      var rolls = layout.rolls;
      var message = 'Order plan: buy ' + rollOrderText(rolls) + '.';

      if (layout.priority === 'waste' || layout.priority === 'seams') {
        message = (layout.priority === 'waste' ? 'Minimize waste' : 'Minimize seams') + ' order plan: buy ' + rollOrderText(rolls) + '.';
      }

      message += ' Estimated waste/repair offcut: ' + formatNumber(layout.actualWasteArea) + ' sq ft.';

      if (layout.priority === 'waste' && layout.remainingWidth > 0) {
        if (layout.segmentsPerCut > 1) {
          message += ' The remaining ' + formatFeet(layout.remainingWidth) + ' ft width is filled with shorter pieces to reduce material.';
        } else {
          message += ' The remaining ' + formatFeet(layout.remainingWidth) + ' ft width does not fit twice across a 15 ft roll, so this size may not save material versus minimizing seams.';
        }
      }

      return message;
    }

    function buildOrderNote() {
      if (selectedCalculatorMode() === 'quick') {
        return [
          'Artificial grass quick order estimate:',
          'Project sq ft: ' + (simpleAreaInput ? simpleAreaInput.value : ''),
          calculatorConfig.copy.noAllowance,
          'Recommendation: ' + orderSummary.textContent,
          'Required coverage: ' + (requiredArea ? requiredArea.textContent : ''),
          'Ordered roll area: ' + (orderArea ? orderArea.textContent : ''),
          'Extra over measured area: ' + (wasteArea ? wasteArea.textContent : ''),
          'Details: ' + rollBreakdown.textContent,
          'Questions: Please confirm the best roll size, shipping options, and blade direction.'
        ].join('\n');
      }

      var advice = directionAdvice();
      var context = directionContext();
      var shape = selectedShape();
      var priority = orderPriorityAvailable(shape) ? selectedOrderPriority() : 'standard';
      var priorityLabel = priority === 'waste' ? 'Minimize waste' : priority === 'seams' ? 'Minimize seams' : 'Standard outside-box estimate';

      return [
        'Artificial grass order estimate:',
        'Shape: ' + shape,
        'Measurements: Side 1 ' + lengthInput.value + ' ft x Side 2 ' + widthInput.value + ' ft',
        'Project area: ' + selectedProjectAreaLabel(),
        'Order priority: ' + priorityLabel,
        'Side guide: ' + context.sideGuide,
        'Roll reference: ' + rollReferenceText(),
        'Direction plan: ' + advice.label + ' - ' + advice.detail,
        cutPlanSummary(),
        'Recommendation: ' + orderSummary.textContent,
        'Layout: ' + layoutSummary.textContent,
        'Required coverage: ' + (requiredArea ? requiredArea.textContent : ''),
        'Ordered roll area: ' + (orderArea ? orderArea.textContent : ''),
        'Extra over measured area: ' + (wasteArea ? wasteArea.textContent : ''),
        'Details: ' + rollBreakdown.textContent,
        'Questions: Please confirm the best roll size, shipping options, and blade direction.'
      ].join('\n');
    }

    function updateQuoteMessage() {
      updateDirectionCheck();

      if (quoteMessage) {
        quoteMessage.value = buildOrderNote();
      }
    }

    function calculateQuick() {
      var projectArea = simpleProjectArea();
      updateCalculatorStateLinks();

      if (!projectArea) {
        currentLayout = null;
        orderSummary.textContent = 'Enter square footage';
        measuredArea.textContent = '0 sq ft';
        if (bufferArea) bufferArea.textContent = '0 sq ft';
        if (requiredArea) requiredArea.textContent = '0 sq ft';
        orderArea.textContent = '0 sq ft';
        layoutSummary.textContent = 'Quick sqft';
        if (wasteArea) wasteArea.textContent = '0 sq ft';
        rollBreakdown.textContent = 'Enter the project square footage to get a fast roll recommendation.';
        alternateLayout.textContent = '';
        updateProductCta(null);
        updateQuoteMessage();
        return;
      }

      var layout = makeQuickLayout(projectArea);
      if (layout.error) {
        currentLayout = null;
        currentCartItems = [];
        orderSummary.textContent = calculatorConfig.copy.checkCuts;
        measuredArea.textContent = formatSqft(projectArea) + ' sq ft';
        if (requiredArea) requiredArea.textContent = formatSqft(projectArea) + ' sq ft';
        orderArea.textContent = calculatorConfig.copy.checkCuts;
        layoutSummary.textContent = calculatorConfig.copy.checkCuts;
        if (wasteArea) wasteArea.textContent = calculatorConfig.copy.checkCuts;
        rollBreakdown.textContent = layout.error === 'too_large' ? calculatorConfig.copy.largeProject : calculatorConfig.copy.unavailablePlan;
        alternateLayout.textContent = '';
        updateProductCta(null);
        updateQuoteMessage();
        return;
      }
      currentLayout = layout;

      orderSummary.textContent = layoutOrderLabel(layout);
      measuredArea.textContent = formatSqft(projectArea) + ' sq ft';
      if (bufferArea) bufferArea.textContent = formatSqft(layout.quickBufferArea) + ' sq ft';
      if (requiredArea) requiredArea.textContent = formatSqft(layout.quickRequiredArea) + ' sq ft';
      orderArea.textContent = formatSqft(layout.orderArea) + ' sq ft';
      layoutSummary.textContent = calculatorConfig.copy.quickSummary;
      if (wasteArea) wasteArea.textContent = formatSqft(layout.actualWasteArea) + ' sq ft';

      var requiredCoverage = layout.quickRequiredArea;
      var detail = 'Quick order plan: buy ' + rollOrderText(layout.rolls) + '. Required coverage is ' + formatSqft(requiredCoverage) + ' ' + calculatorConfig.copy.coverageSuffix;

      if (layout.orderArea > requiredCoverage) {
        detail += ' The final order covers ' + formatSqft(layout.orderArea) + ' sq ft because of roll-length rounding.';
      }

      rollBreakdown.textContent = detail;
      alternateLayout.textContent = 'Switch to Detailed layout for shapes, seams, blade direction, and wider-than-15-ft cut planning.';
      updateProductCta(layout);
      updateQuoteMessage();
    }

    function calculate() {
      if (selectedCalculatorMode() === 'quick') {
        calculateQuick();
        return;
      }

      var length = Math.max(0, Number(lengthInput.value));
      var width = Math.max(0, Number(widthInput.value));
      var allowance = 0;
      var measured = length * width;
      var shape = selectedShape();
      var guide = guides[shape] || guides.rectangle;
      var context = directionContext();

      guideTitle.textContent = guide.title;
      shapeNote.textContent = guide.note + ' ' + context.sideGuide;
      guideList.innerHTML = guide.steps.map(function(step) {
        return '<li>' + step + '</li>';
      }).join('');
      updatePriorityControl(shape);
      updateCalculatorStateLinks();
      updateDiagramContext(shape);
      diagramShape.className = 'turf-calculator__diagram-shape is-' + shape;
      updateMeasurementDiagram(length, width, shape);

      if (!length || !width) {
        currentLayout = null;
        orderSummary.textContent = 'Enter measurements';
        measuredArea.textContent = '0 sq ft';
        if (bufferArea) bufferArea.textContent = '0 sq ft';
        if (requiredArea) requiredArea.textContent = '0 sq ft';
        orderArea.textContent = '0 sq ft';
        layoutSummary.textContent = 'Waiting for size';
        if (wasteArea) wasteArea.textContent = '0 sq ft';
        rollBreakdown.textContent = 'Add the longest and widest measurements to get an order recommendation.';
        alternateLayout.textContent = '';
        updateProductCta(null);
        updateQuoteMessage();
        return;
      }

      var best;
      var alternate;
      var priorityAvailable = orderPriorityAvailable(shape);
      var priority = priorityAvailable ? selectedOrderPriority() : 'seams';

      if (priorityAvailable) {
        var seamLayout = completeLayout(makeDirectionLayout(length, width), allowance, measured);
        var wasteLayout = completeLayout(makeDirectionWasteLayout(length, width), allowance, measured);

        if (priority === 'waste') {
          best = wasteLayout;
          alternate = seamLayout;
        } else {
          best = seamLayout;
          alternate = wasteLayout;
        }
      } else if (keepDirectionConsistent()) {
        best = completeLayout(makeDirectionLayout(length, width), allowance, measured);
        alternate = completeLayout(makeRotatedLayout(length, width), allowance, measured);
      } else {
        var layouts = [
          makeLayout('Run the roll along the longest measurement', length, width),
          makeLayout('Rotate the layout', width, length)
        ].map(function(layout) {
          return completeLayout(layout, allowance, measured);
        }).sort(function(a, b) {
          if (a.orderArea !== b.orderArea) return a.orderArea - b.orderArea;
          return a.seams - b.seams;
        });

        best = layouts[0];
        alternate = layouts[1];
      }

      orderSummary.textContent = layoutOrderLabel(best);
      currentLayout = best;
      measuredArea.textContent = formatSqft(measured) + ' sq ft';
      if (bufferArea) bufferArea.textContent = formatSqft(measured * allowance) + ' sq ft';
      if (requiredArea) requiredArea.textContent = formatSqft(measured * (1 + allowance)) + ' sq ft';
      orderArea.textContent = formatSqft(best.orderArea) + ' sq ft';
      layoutSummary.textContent = layoutSummaryText(best);
      if (wasteArea) wasteArea.textContent = formatSqft(best.actualWasteArea) + ' sq ft';
      rollBreakdown.textContent = describeRolls(best);
      updateProductCta(best);

      if (priorityAvailable) {
        alternateLayout.textContent = comparisonText(best, alternate);
      } else if (keepDirectionConsistent()) {
        alternateLayout.textContent = cutPlanSummary() + ' This keeps the blade direction facing the ' + targetDirectionLabel() + '.';
      } else if (alternate && alternate.orderArea !== best.orderArea) {
        alternateLayout.textContent = 'Alternate layout: ' + alternate.strips + (alternate.strips === 1 ? ' strip' : ' strips') + ', about ' + formatNumber(alternate.orderArea) + ' sq ft coverage.';
      } else {
        alternateLayout.textContent = 'Both directions are similar. Choose the layout that keeps the turf blade direction consistent.';
      }

      if (shape === 'lshape' || shape === 'multi') {
        alternateLayout.textContent = guide.note + ' Use this result for the current outside rectangle only. ' + cutPlanSummary();
      }

      updateQuoteMessage();
    }

    function copyNote() {
      var note = buildOrderNote();

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(note);
      }

      copyButton.textContent = 'Copied';
      copyButton.classList.add('is-copied');

      window.setTimeout(function() {
        copyButton.textContent = 'Copy order note';
        copyButton.classList.remove('is-copied');
      }, 1800);
    }

    modeInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        setCalculatorMode(input.value);
        calculate();
      });
    });
    if (simpleAreaInput) simpleAreaInput.addEventListener('input', calculate);
    lengthInput.addEventListener('input', calculate);
    widthInput.addEventListener('input', calculate);
    if (projectAreaInput) projectAreaInput.addEventListener('change', calculate);
    if (keepDirectionInput) keepDirectionInput.addEventListener('change', calculate);
    priorityInputs.forEach(function(input) {
      input.addEventListener('change', calculate);
    });
    copyButton.addEventListener('click', copyNote);
    if (productAddButton) productAddButton.addEventListener('click', addRecommendedProduct);

    productChoiceLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

        var handle = link.dataset.productChoice;
        if (!handle) return;

        event.preventDefault();
        selectSourceProduct(handle);

        if (productCta) {
          productCta.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        }
      });
    });

    shapeInputs.forEach(function(input) {
      input.addEventListener('change', calculate);
    });

    renderAccessories();
    bindAccessoryEvents();
    applyUrlState();
    setNextStepMode();
    calculate();
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-turf-calculator-root]'), initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
